<template>
  <div id="app">
    <nav class="navbar" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <router-link class="navbar-item" to="/">
          <span>TRBC Youth App</span>
        </router-link>
        <div
          class="navbar-burger burger"
          v-bind:class="{ 'is-active': mobileMenuActive }"
          @click="toggleMobileMenu"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div class="navbar-menu" v-bind:class="{ 'is-active': mobileMenuActive }">
        <div class="navbar-end">
          <div class="navbar-item">
            <b-dropdown class="is-right">
              <button class="button" slot="trigger">
                <figure class="image is-24x24" v-if="currentUser">
                  <img :src="currentUser.photoURL">
                </figure>
                <span v-else>Settings</span>
              </button>
              <b-dropdown-item v-if="currentUser">
                <span class="display-name">{{ currentUser.displayName }}</span>
              </b-dropdown-item>
              <b-dropdown-item>
                <router-link to="/termsandconditions">Terms and Conditions</router-link>
              </b-dropdown-item>
              <b-dropdown-item>
                <router-link to="/privacy">Privacy Policy</router-link>
              </b-dropdown-item>
              <b-dropdown-item v-if="currentUser">
                <a href="#" v-on:click="signOut">Sign Out</a>
              </b-dropdown-item>
              <b-dropdown-item>
                <span class="display-name">Version {{ version }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </nav>
    <div class="app-content container">
      <router-view/>
    </div>
  </div>
</template>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  text-align: center;
}
#nav .a {
  font-weight: bold;
  color: #2c3e50;
  &.router-link-exact-active {
    color: #42b983;
  }
}
.app-content {
  margin-left: auto;
  margin-right: auto;
  width: 90%;
}
</style>

<script>
import Vue from "vue";
import Buefy from "buefy";
import "buefy/dist/buefy.css";
import { firebase } from "@/firebase";

//import "font-awesome/css/font-awesome.min.css";
// Vue.use(Buefy, {
//   defaultIconPack: "fa"
// });

Vue.use(Buefy);

export default {
  data() {
    return {
      mobileMenuActive: false,
      version: "1.0"
    };
  },
  mounted () {
    this.determineBrowserDimensions();
  },
  computed: {
    currentUser: function() {
      return this.$store.getters.getUser;
    }
  },
  methods: {
    signOut: function() {
      this.$store.dispatch("updateUser", null);
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push({ name: "signin" });
        })
        .catch(error => {
          console.log("Failed Signed out" + error);
        });
    },
    toggleMobileMenu: function() {
      this.mobileMenuActive = !this.mobileMenuActive;
    },
    determineBrowserDimensions: function() {
      //> HEIGHT
      let vh = window.innerHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty("--vh", `${vh}px`);
      // We listen to the resize event
      window.addEventListener("resize", () => {
        // We execute the same script as before
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
      });
    }
  }
};
</script>

<style scoped>
#app {
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
}
</style>